var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"use-immediate"},[_c('div',{staticClass:"title"},[_vm._v("立即注册，免费试用30天，体验私域高效增长之旅！")]),_c('div',{staticClass:"btn",on:{"click":_vm.showQrcode}},[_vm._v("联系客服")])])
}
var staticRenderFns = []

export { render, staticRenderFns }